import {
  AnalyticsPieIcon,
  BankTransferIcon,
  CashPaymentBillIcon,
  CreditCardIcon,
  HdfcIcon,
  IciciBankIcon,
  PlantPotIcon,
  SbiIcon,
} from '@flywire/icons';
import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';
import CredilaLogoUrl from 'icons/HDFC-credila-logo.png';
import AvanseLogoUrl from 'icons/avanse-logo.png';
import { sourceOfFunds } from 'services/payex/sourceOfFunds/sourceOfFunds';
type SourceOfFundsMap = Record<
  string,
  {
    name: string;
    financialInstitutions: {
      name: string;
    }[];
  }
>;

const useSourceOfFunds = () => {
  return useQuery(
    ['sourceOfFundsIndia'],
    async () => {
      const response = await sourceOfFunds.get();

      return response.reduce((acc, item) => {
        acc[item.name] = item;
        return acc;
      }, {} as SourceOfFundsMap);
    },
    {
      refetchInterval: false,
    },
  );
};

const sourceOfFundsIcons = {
  savings: PlantPotIcon,
  loan: CashPaymentBillIcon,
  education_loan_and_savings: AnalyticsPieIcon,
  other: CreditCardIcon,
};

const financialInstitutionsIcons = {
  avanse: () => (
    <img
      alt="avanse"
      className="lg:max-w-20 max-w-14"
      src={AvanseLogoUrl}
      aria-hidden
      loading="lazy"
    />
  ),
  credila: () => (
    <img
      alt="HDFC Credila"
      className="lg:max-w-20 max-w-14"
      src={CredilaLogoUrl}
      aria-hidden
      loading="lazy"
    />
  ),
  hdfc: HdfcIcon,
  icici: IciciBankIcon,
  sbi: SbiIcon,
  otherBanks: ({ className }: { className: string }) => (
    <BankTransferIcon className={classNames('fill-[#A58EE7]', className)} />
  ),
  otherNBFCs: ({ className }: { className: string }) => (
    <BankTransferIcon className={classNames('fill-blue-800', className)} />
  ),
};

export {
  useSourceOfFunds,
  type SourceOfFundsMap,
  sourceOfFundsIcons,
  financialInstitutionsIcons,
};
